<main class="details-page">
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-xxl-1"></div>
      <div class="col-12 col-xxl-10">
        <div class="card details-shell">
          <div class="card-header details-header">
            <div class="details-heading-row">
              <div>
                <h1 class="details-title">Service Request Details</h1>
                @if (details(); as requestDetails) {
                <div class="request-identity">
                  <p class="details-subtitle mb-0">
                    {{ formatServiceRequestId(requestDetails.serviceRequest.serviceRequestId) }}
                  </p>
                  <div class="request-status">
                    <span class="visually-hidden">Status:</span>
                    <span class="chip-outline" [class]="getStatusClass(requestDetails.serviceRequest.status)">
                      {{ getStatusDisplay(requestDetails.serviceRequest.status) | titlecase }}
                    </span>
                  </div>
                </div>
                }
              </div>

              <a class="btn btn-primary btn-md back-button" routerLink="/service-request-history"
                aria-label="Return to Service Request" mdbRipple>
                <i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>
                Return to Service Request
              </a>
            </div>

          </div>

          <div class="card-body p-0">
            @if (isLoading()) {
            <div class="loading-state" role="status">
              <div class="spinner-border text-primary" aria-hidden="true"></div>
              <span class="visually-hidden">Loading service request details...</span>
              <p class="mt-3 mb-0">Loading service request details...</p>
            </div>
            } @else if (errorMessage(); as error) {
            <div class="error-state" role="alert">
              <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
              <h2>Unable to load request</h2>
              <p>{{ error }}</p>
              <button type="button" class="btn btn-primary" (click)="retry()">Try Again</button>
            </div>
            } @else if (details(); as requestDetails) {
            <mdb-tabs #tabs [fill]="true" (activeTabChange)="onTabChange($event)">
              <mdb-tab>
                <ng-template mdbTabTitle>
                  <span class="tab-title" title="Summary">
                    <i class="fa-solid fa-list-ul tab-icon" aria-hidden="true"></i>
                    <span class="tab-label">Summary</span>
                  </span>
                </ng-template>
                <ng-template mdbTabContent>
                  <section class="tab-panel summary-content" aria-label="Service request summary and attachments">
                    <div class="summary-panel" aria-labelledby="summary-heading">
                      <h2 id="summary-heading" class="section-title">Summary View</h2>
                      <dl class="details-grid">
                      <div class="detail-item">
                        <dt>Customer</dt>
                        <dd>{{ getUserName() }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Email</dt>
                        <dd>{{ getUserEmail() }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Phone</dt>
                        <dd>{{ getUserPhoneNumber() }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Case #</dt>
                        <dd>{{ requestDetails.serviceRequest.caseNumber || 'N/A' }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Request Type</dt>
                        <dd>{{ requestDetails.serviceRequest.category || 'N/A' }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Case Type</dt>
                        <dd>{{ requestDetails.serviceRequest.caseType || 'N/A' }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Sub Case Type</dt>
                        <dd>{{ requestDetails.serviceRequest.subCaseType || 'N/A' }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Form Type</dt>
                        <dd>{{ requestDetails.serviceRequest.formType || 'N/A' }}</dd>
                      </div>
                      @if (requestDetails.serviceRequest.formTypeOtherText) {
                      <div class="detail-item">
                        <dt>Form Details</dt>
                        <dd>{{ requestDetails.serviceRequest.formTypeOtherText }}</dd>
                      </div>
                      }
                      <div class="detail-item detail-item-wide">
                        <dt>Description</dt>
                        <dd>{{ requestDetails.serviceRequest.description }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Contact Method</dt>
                        <dd>
                          {{ requestDetails.serviceRequest.preferredContact
                            ? (requestDetails.serviceRequest.preferredContact | titlecase)
                            : 'N/A' }}
                        </dd>
                      </div>
                      <div class="detail-item">
                        <dt>Language</dt>
                        <dd>
                          {{ requestDetails.serviceRequest.preferredLanguage
                            ? (requestDetails.serviceRequest.preferredLanguage | titlecase)
                            : 'N/A' }}
                        </dd>
                      </div>
                      <div class="detail-item">
                        <dt>Visited Before:</dt>
                        <dd>
                          {{ requestDetails.serviceRequest.visitedBefore
                            ? (requestDetails.serviceRequest.visitedBefore | titlecase)
                            : '' }}
                        </dd>
                      </div>
                      <div class="detail-item">
                        <dt>Last Updated</dt>
                        <dd>{{ formatDate(requestDetails.serviceRequest.modifiedDate) }}</dd>
                      </div>
                      <div class="detail-item">
                        <dt>Submitted</dt>
                        <dd>{{ formatDate(requestDetails.serviceRequest.submittedDate) }}</dd>
                      </div>
                      @if (requestDetails.serviceRequest.closedDate) {
                      <div class="detail-item">
                        <dt>Closed</dt>
                        <dd>{{ formatDate(requestDetails.serviceRequest.closedDate) }}</dd>
                      </div>
                      }
                      </dl>
                    </div>

                    <div class="attachments-panel" aria-labelledby="attachments-heading">
                      <div class="attachments-heading-row">
                        <h2 id="attachments-heading" class="section-title">Service Request Attachments</h2>
                        <span class="attachment-count">
                          {{ attachments().length }} {{ attachments().length === 1 ? 'file' : 'files' }}
                        </span>
                      </div>

                      @if (attachments().length > 0) {
                      <div class="attachment-filter mb-4">
                        <label for="attachment-filter" class="form-label">Search attachments</label>
                        <input id="attachment-filter" type="search" class="form-control"
                          placeholder="File name, uploaded by, extension, or date"
                          (input)="filterAttachments($event)" />
                      </div>

                      <div class="attachment-sort-controls d-md-none mb-4">
                        <div class="flex-grow-1">
                          <label for="attachment-sort" class="form-label">Sort attachments</label>
                          <select id="attachment-sort" class="form-select" [value]="attachmentSort()"
                            (change)="changeAttachmentSort($event)">
                            <option value="date">Date</option>
                            <option value="fileName">File Name</option>
                            <option value="uploadedBy">Uploaded By</option>
                            <option value="size">Size</option>
                          </select>
                        </div>
                        <button type="button" class="btn btn-outline-primary sort-direction-button"
                          (click)="toggleAttachmentSortDirection()"
                          [attr.aria-label]="attachmentSortDirection() === 'asc'
                            ? 'Sort attachments descending'
                            : 'Sort attachments ascending'">
                          <i class="fa-solid"
                            [class.fa-arrow-up-wide-short]="attachmentSortDirection() === 'asc'"
                            [class.fa-arrow-down-wide-short]="attachmentSortDirection() === 'desc'"
                            aria-hidden="true"></i>
                        </button>
                      </div>
                      }

                      @if (filteredAttachments().length > 0) {
                      <div class="table-responsive d-none d-md-block">
                        <table class="table align-middle attachment-table">
                          <caption class="visually-hidden">Attachments for this service request</caption>
                          <thead>
                            <tr>
                              <th scope="col" [attr.aria-sort]="getAttachmentAriaSort('uploadedBy')">
                                <button type="button" class="sort-header" (click)="setAttachmentSort('uploadedBy')">
                                  Uploaded By
                                  <i class="fa-solid" [class]="getAttachmentSortIcon('uploadedBy')"
                                    aria-hidden="true"></i>
                                </button>
                              </th>
                              <th scope="col" [attr.aria-sort]="getAttachmentAriaSort('fileName')">
                                <button type="button" class="sort-header" (click)="setAttachmentSort('fileName')">
                                  File Name
                                  <i class="fa-solid" [class]="getAttachmentSortIcon('fileName')"
                                    aria-hidden="true"></i>
                                </button>
                              </th>
                              <th scope="col" [attr.aria-sort]="getAttachmentAriaSort('date')">
                                <button type="button" class="sort-header" (click)="setAttachmentSort('date')">
                                  Date
                                  <i class="fa-solid" [class]="getAttachmentSortIcon('date')"
                                    aria-hidden="true"></i>
                                </button>
                              </th>
                              <th scope="col" [attr.aria-sort]="getAttachmentAriaSort('size')">
                                <button type="button" class="sort-header" (click)="setAttachmentSort('size')">
                                  Size
                                  <i class="fa-solid" [class]="getAttachmentSortIcon('size')"
                                    aria-hidden="true"></i>
                                </button>
                              </th>
                              <th scope="col">File</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (document of pagedAttachments(); track document.serviceRequestDocumentId) {
                            <tr>
                              <td>{{ getUploadSource(document) }}</td>
                              <td class="attachment-name">
                                <i class="fa-solid me-2" [class]="getDocumentIcon(document.fileExtension)"
                                  aria-hidden="true"></i>
                                {{ document.originalFileName }}
                              </td>
                              <td>{{ formatDate(document.createdDate) }}</td>
                              <td>{{ formatFileSize(document.fileSizeBytes) }}</td>
                              <td>
                                <a [href]="document.fileUrl" target="_blank" rel="noopener"
                                  class="btn btn-sm btn-primary"
                                  [attr.aria-label]="'View attachment ' + document.originalFileName">
                                  <i class="fa-solid fa-file-arrow-down" aria-hidden="true"></i>
                                  <span class="visually-hidden">View</span>
                                </a>
                              </td>
                            </tr>
                            }
                          </tbody>
                        </table>
                      </div>

                      <div class="attachment-list d-md-none" role="list" aria-label="Attachments">
                        @for (document of pagedAttachments(); track document.serviceRequestDocumentId) {
                        <article class="attachment-tile" role="listitem">
                          <div class="attachment-tile-heading">
                            <i class="fa-solid" [class]="getDocumentIcon(document.fileExtension)"
                              aria-hidden="true"></i>
                            <h3>{{ document.originalFileName }}</h3>
                          </div>
                          <dl>
                            <div><dt>Uploaded by</dt><dd>{{ getUploadSource(document) }}</dd></div>
                            <div><dt>Date</dt><dd>{{ formatDate(document.createdDate) }}</dd></div>
                            <div><dt>Size</dt><dd>{{ formatFileSize(document.fileSizeBytes) }}</dd></div>
                          </dl>
                          <a [href]="document.fileUrl" target="_blank" rel="noopener"
                            class="btn btn-primary w-100"
                            [attr.aria-label]="'View attachment ' + document.originalFileName">
                            <i class="fa-solid fa-file-arrow-down me-2" aria-hidden="true"></i>
                            View File
                          </a>
                        </article>
                        }
                      </div>

                      <div class="attachment-pagination">
                        <p class="attachment-range mb-0">
                          Showing {{ getAttachmentRangeStart() }}–{{ getAttachmentRangeEnd() }}
                          of {{ filteredAttachments().length }}
                        </p>
                        @if (attachmentPageCount() > 1) {
                        <nav aria-label="Attachment pages">
                          <ul class="pagination pagination-sm mb-0">
                            <li class="page-item" [class.disabled]="attachmentPage() === 1">
                              <button type="button" class="page-link"
                                [disabled]="attachmentPage() === 1"
                                (click)="setAttachmentPage(attachmentPage() - 1)"
                                aria-label="Previous attachment page">
                                <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
                              </button>
                            </li>
                            @for (page of attachmentPageNumbers(); track page) {
                            <li class="page-item" [class.active]="attachmentPage() === page">
                              <button type="button" class="page-link"
                                [attr.aria-current]="attachmentPage() === page ? 'page' : null"
                                (click)="setAttachmentPage(page)">{{ page }}</button>
                            </li>
                            }
                            <li class="page-item" [class.disabled]="attachmentPage() === attachmentPageCount()">
                              <button type="button" class="page-link"
                                [disabled]="attachmentPage() === attachmentPageCount()"
                                (click)="setAttachmentPage(attachmentPage() + 1)"
                                aria-label="Next attachment page">
                                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
                              </button>
                            </li>
                          </ul>
                        </nav>
                        }
                      </div>
                      } @else if (attachments().length > 0) {
                      <div class="tab-empty-state" role="status">
                        <i class="fa-solid fa-filter-circle-xmark" aria-hidden="true"></i>
                        <p>No attachments match your search.</p>
                      </div>
                      } @else {
                      <div class="tab-empty-state" role="status">
                        <i class="fa-solid fa-paperclip" aria-hidden="true"></i>
                        <p>No attachments have been added to this request.</p>
                      </div>
                      }
                    </div>
                  </section>
                </ng-template>
              </mdb-tab>

              @if (requestDetails.serviceRequest.assignedToUserId !== null) {
              <mdb-tab>
                <ng-template mdbTabTitle>
                  <span class="tab-title" title="Conversations">
                    <i class="fa-solid fa-comments tab-icon" aria-hidden="true"></i>
                    <span class="tab-label">Conversations</span>
                  </span>
                </ng-template>
                <ng-template mdbTabContent>
                  <section class="tab-panel conversation-panel" aria-label="Conversations">
                    <app-conversation
                      [serviceRequestId]="requestDetails.serviceRequest.serviceRequestId"
                      [serviceRequestDocuments]="requestDetails.serviceRequestDocuments"
                      (attachmentsUploaded)="refreshDetails()" />
                  </section>
                </ng-template>
              </mdb-tab>
              }

            </mdb-tabs>
            }
          </div>
        </div>

        <app-gradientsegmentbar></app-gradientsegmentbar>
      </div>
      <div class="col-xxl-1"></div>
    </div>
  </div>
</main>
